import { cn } from "../lib/utils";

/** First letters of the first and last name part, upper-cased. */
export function initialsOf(name: string): string {
  const parts = name.trim().split(/\s+/).filter((part) => part.length > 0);
  const first = parts[0]?.[0] ?? "";
  const last = parts.length > 1 ? (parts[parts.length - 1]?.[0] ?? "") : "";
  return `${first}${last}`.toUpperCase() || "?";
}

/**
 * Shared initials monogram (K6): a round avatar derived from a display name.
 * Extracted from the app-shell user card so the same idiom reads across the
 * timeline author line, the admin-users rows/cards and the Zuordnung owner.
 * Decorative by default (aria-hidden) - the name always shows next to it.
 */
export function InitialsAvatar({
  name,
  size = "md",
  className,
}: {
  name: string;
  size?: "sm" | "md";
  className?: string;
}): JSX.Element {
  return (
    <span
      aria-hidden="true"
      className={cn(
        "inline-flex shrink-0 items-center justify-center rounded-full bg-primary/10 font-semibold text-primary-text",
        size === "sm" ? "h-6 w-6 text-[0.65rem]" : "h-9 w-9 text-sm",
        className,
      )}
    >
      {initialsOf(name)}
    </span>
  );
}
